"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.classes = exports.LunaSearchSizes = void 0;

var _sizes;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var LunaSearchSizes = {
  s20: 's20',
  s10: 's10'
};
exports.LunaSearchSizes = LunaSearchSizes;
var __baseClass = 'luna-form_control-search';
var __inputBaseClass = 'luna-form_control--input';
var __infoBoxBaseClass = 'luna-form_control--info_box';
var classes = {
  actionClear: 'luna-form_control--action_clear',
  actionSearch: 'luna-form_control--action_search_icon',
  base: __baseClass,
  groupTitle: "luna-form_control--group_title",
  isDisabled: "".concat(__baseClass, "-is_disabled"),
  isPopulated: "".concat(__baseClass, "-is_populated"),
  sizes: (_sizes = {}, _defineProperty(_sizes, LunaSearchSizes.s20, "".concat(__baseClass, "-size-20")), _defineProperty(_sizes, LunaSearchSizes.s10, "".concat(__baseClass, "-size-10")), _sizes),
  inputBase: __inputBaseClass,
  inputSmall: "".concat(__inputBaseClass, "-small"),
  infoBoxAction: "".concat(__infoBoxBaseClass, "--action"),
  infoBoxBase: __infoBoxBaseClass,
  infoBoxList: "".concat(__infoBoxBaseClass, "_list"),
  infoBoxItem: "".concat(__infoBoxBaseClass, "_item"),
  infoBoxItemAction: "".concat(__infoBoxBaseClass, "_item_action"),
  infoBoxItemActionSubtype: "".concat(__infoBoxBaseClass, "_item_action_subtype"),
  infoBoxItemActionIsActive: "".concat(__infoBoxBaseClass, "_item_action-is_active"),
  infoBoxItemActionIsDisabled: "".concat(__infoBoxBaseClass, "_item_action-is_disabled"),
  infoBoxItemSeparator: "".concat(__infoBoxBaseClass, "_item_separator")
};
exports.classes = classes;
